import ResponsiveStyleSheet from "react-native-media-query";
import { theme } from "../../theme";
import { createResponsiveStyles } from "../../utils/createResponsiveStyles";
export const { styles, ids } = ResponsiveStyleSheet.create({
    segmentContainer: createResponsiveStyles({
        base: {
            alignItems: "flex-start",
        },
        medium: {
            alignItems: "flex-end",
        },
    }),
    bannerContainer: {
        flexDirection: "row",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "center",
    },
    header: {
        flexDirection: "row",
        justifyContent: "space-between",
    },
    logo: {
        marginRight: theme.spacing.medium,
    },
    fontBold: {
        fontWeight: "700",
    },
    fontSemibold: {
        fontWeight: "600",
    },
    fontNormal: {
        fontWeight: "400",
    },
    fontSize: createResponsiveStyles({
        xsmall: {
            fontSize: theme.fontDefaults.xsmall.fontSize,
        },
        medium: {
            fontSize: theme.fontDefaults.large.fontSize,
        },
    }),
    footer: {
        opacity: 0.5,
        fontSize: theme.fontDefaults.xsmall.fontSize,
        marginTop: theme.spacing.xsmall2,
    },
    separator: {
        color: "#1bb57d",
        marginHorizontal: theme.spacing.small,
    },
    leftCircle: {
        marginRight: theme.spacing.small,
    },
    rightCircle: {
        marginLeft: theme.spacing.small,
    },
    panel: {
        marginVertical: theme.spacing.small,
    },
});
//# sourceMappingURL=Trustpilot.styles.js.map